import { render } from "./WalksView.vue?vue&type=template&id=f1f0c5d4&scoped=true"
import script from "./WalksView.vue?vue&type=script&lang=js"
export * from "./WalksView.vue?vue&type=script&lang=js"

import "./WalksView.vue?vue&type=style&index=0&id=f1f0c5d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f0c5d4"]])

export default __exports__